import React, { useState } from 'react';
import rocket from '../../assets/img/rocket.svg';
import Card from 'react-bootstrap/Card';
import { Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import WizardModal from '../modal/WizardModal';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store/rootReducer';
import { toggleStartMockingPanelThunk } from '../../store/ui/startMockingBanner/startMockingBannerActions';
import BzmIcon from '../icons/BzmIcon';

const WizardBanner = () => {
  const showStartMocking = useSelector((state: ApplicationState) => state.ui.showStartMockingBanner);
  const [isWizardShown, setIsWizardShown] = useState(false);
  const dispatch = useDispatch();

  if (showStartMocking === false) {
    return null;
  }

  return (
    <Card className={'p-4 mb-4'}>
      {isWizardShown && (
        <WizardModal
          onClose={() => {
            setIsWizardShown(false);
          }}
        />
      )}
      <Row>
        <div className="col-md-2 col-lg-1">
          <img src={rocket} className={'img-fluid'} alt="Rocket Illustration" />
        </div>
        <div className="col-md-6 col-lg-8">
          <h4 className={'mt-5 mb-1'}>Create Your Virtual Service with Help of a Wizard</h4>
          <p>
            <span className={'mr-3'}>
              You are just a few steps away from creating your Virtual Service and experiencing the benefits that
              virtualization brings.
            </span>
            <Button
              style={{ bottom: '1px' }}
              className={'p-0 m-0 border-0 position-relative'}
              variant={'link'}
              onClick={() => {
                setIsWizardShown(true);
              }}
            >
              Start Virtualizing Now
            </Button>
          </p>
        </div>
        <div className="col-md-4 col-lg-3">
          <div className={'mt-9 text-right'}>
            {/*<Button*/}
            {/*  className={'btn-no-hover'}*/}
            {/*  variant={'link'}*/}
            {/*  onClick={() => {*/}
            {/*    dispatch(toggleStartMockingPanelThunk());*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <BzmIcon variant={'icon-bzm-hide'} className={'mr-3'} />*/}
            {/*  Don&apos;t Show This Banner Again*/}
            {/*</Button>*/}
          </div>
        </div>
      </Row>
    </Card>
  );
};

export default WizardBanner;
